

import { ROUTE_BASE_URL } from '../api/common';

import Testing from '../components/testing';
// import Login from '../components/Authentication/login';
// import Signup from '../components/Authentication/signup';
// import ForgotPassword from '../components/Authentication/forgotpassword';
// import NotFound from '../components/Authentication/404';
import Notifications from '../components/Components/Notifications';

//-----Dashboard
import Dashboard from '../components/Dashboard/dashboard';

//-----Membership Application
import MembershipPackage from '../components/MembershipApplication/membership-package/membership-package';
import ApplicationStatus from '../components/Master/application-status/application-status';
import MembershipApplication from '../components/MembershipApplication/membership-application';
import MembershipApplicationDetails from '../components/MembershipApplication/membership-application-details';
import MembershipApplicationDetailsStatus from '../components/MembershipApplication/membership-application-details-status';
import AllMembershipApplicationDetailsStatus from '../components/MembershipApplication/all-membership-application-details-status';

//-----AdminUser
import AdminUsers from '../components/AdminUsers/admin-users';
import AdminUserRole from '../components/AdminUsers/role-type/role-type';
import AdminUserPermission from '../components/AdminUsers/role-permission/role-premission';
import MyProfile from '../components/AdminUsers/my-profile';
import AccessDenied from '../components/Authentication/access-denied';

//-----Common Masters
import Gst from '../components/Master/gst/gst';
import GstType from '../components/Master/gst-type/gst-type';
import PaymentStatus from '../components/Master/payment-status/payment-status';
import ReviewStatus from '../components/Master/review-status/review-status';
import Currency from '../components/Master/currency/currency';
import Country from '../components/Master/country/country';
import MembershipCertificate from '../components/Master/membership-certificate/certificate';
import FMASCertificate from '../components/Master/FMAS-certificate/certificate';

//-----User Membership Application
// import UserMemberApplication from "./UserMembershipApplication/user-member-application";
// import UserMemberApplicationList from "./UserMembershipApplication/user-member-application-list";
// import PaymentSuccess from "./UserMembershipApplication/Success";

// const ROUTE_BASE_URL = `${ROUTE_BASE_URL}/admin";

//-----Reports
import MembershipApplicationReports from '../components/MembershipApplication/reports/membership-application-reports';
import MembershipApplicationPaymentReports from '../components/MembershipApplication/reports/membership-application-payment-reports';

//-----Settings
import Sttings from '../components/settings/settings';

// ----invoice
import Invoice from "../components/Template/invoice";
import Payment from "../components/Template/payment";
import PushNotification from '../components/Master/push-notification/push-notification';
import ApplicationQueries from '../components/Master/application-queries/application-queries';
const Routes = [
    {
        path: `${ROUTE_BASE_URL}/testing`,
        name: 'testing',
        exact: true,
        pageTitle: "Testing",
        component: Testing
    },
    {
        path: ROUTE_BASE_URL,
        name: 'membership-application',
        exact: true,
        pageTitle: "Membership Application",
        component: MembershipApplication
    },
    // {
    //     path: `${ROUTE_BASE_URL}/",
    //     name: 'dashboard',
    //     exact: true,
    //     pageTitle: "Dashboard",
    //     component: Dashboard
    // },
    {
        path: `${ROUTE_BASE_URL}/dashboard`,
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Dashboard
    },
    {
        path: `${ROUTE_BASE_URL}/member-package`,
        name: 'member-package',
        exact: true,
        pageTitle: "Member Package",
        component: MembershipPackage
    },

    {
        path: `${ROUTE_BASE_URL}/membership-application`,
        name: 'membership-application',
        exact: true,
        pageTitle: "Membership Application",
        component: MembershipApplication
    },
    {
        path: `${ROUTE_BASE_URL}/membership-application/:slug`,
        name: 'membership-application-details',
        exact: true,
        pageTitle: "Membership Application Details",
        component: MembershipApplicationDetails
    },
    {
        path: `${ROUTE_BASE_URL}/membership-application/:slug/:slug`,
        name: 'membership-application-details',
        exact: true,
        pageTitle: "Membership Application Details",
        component: MembershipApplicationDetailsStatus
    },
    {
        path: `${ROUTE_BASE_URL}/all-membership-application/:slug`,
        name: 'all membership application details',
        exact: true,
        pageTitle: "All Membership Application Details",
        component: AllMembershipApplicationDetailsStatus
    },
    {
        path: `${ROUTE_BASE_URL}/membership-application-reports`,
        name: 'membership application reports',
        exact: true,
        pageTitle: "Membership Application Reports",
        component: MembershipApplicationReports
    },
    {
        path: `${ROUTE_BASE_URL}/membership-application-payment-reports`,
        name: 'membership application payment reports',
        exact: true,
        pageTitle: "Membership Application Payment Reports",
        component: MembershipApplicationPaymentReports
    },
    // {
    //     path: `${ROUTE_BASE_URL}/user-member-application/:slug`,
    //     name: 'User Member Application',
    //     exact: true,
    //     pageTitle: "UserMemberApplication",
    //     component: UserMemberApplication
    // },
    // {
    //     path: `${ROUTE_BASE_URL}/user-member-application-list`,
    //     name: 'user member application list',
    //     exact: true,
    //     pageTitle: "User Member Application List`,
    //     component: UserMemberApplicationList
    // },
    // {
    //     path: `${ROUTE_BASE_URL}/user-member-application-payment/:slug`,
    //     name: 'user member application Payment',
    //     exact: true,
    //     pageTitle: "User Member Application Payment",
    //     component: PaymentSuccess
    // },
    {
        path: `${ROUTE_BASE_URL}/admin-users`,
        name: 'admin-users',
        exact: true,
        pageTitle: "Admin Users",
        component: AdminUsers
    },
    {
        path: `${ROUTE_BASE_URL}/admin-user-role`,
        name: 'admin-user-role',
        exact: true,
        pageTitle: "Admin User Role",
        component: AdminUserRole
    },
    {
        path: `${ROUTE_BASE_URL}/admin-user-permission/:slug`,
        name: 'admin-user-permission',
        exact: true,
        pageTitle: "Admin User Permission",
        component: AdminUserPermission
    },
    {
        path: `${ROUTE_BASE_URL}/my-profile`,
        name: 'my-profile',
        exact: true,
        pageTitle: "My Profile",
        component: MyProfile
    },
    {
        path: `${ROUTE_BASE_URL}/country`,
        name: 'country',
        exact: true,
        pageTitle: "country",
        component: Country
    },
    {
        path: `${ROUTE_BASE_URL}/gst`,
        name: 'GST',
        exact: true,
        pageTitle: "gst",
        component: Gst
    },
    {
        path: `${ROUTE_BASE_URL}/gst-type`,
        name: 'GST Type',
        exact: true,
        pageTitle: "gst type",
        component: GstType
    },
    {
        path: `${ROUTE_BASE_URL}/payment-status`,
        name: 'Payment Status',
        exact: true,
        pageTitle: "payment status",
        component: PaymentStatus
    },
    // {
    //     path: `${ROUTE_BASE_URL}/application-status`,
    //     name: 'Application Status',
    //     exact: true,
    //     pageTitle: "application status",
    //     component: ApplicationStatus
    // },
    {
        path: `${ROUTE_BASE_URL}/review-status`,
        name: 'Review Status',
        exact: true,
        pageTitle: "review status",
        component: ReviewStatus
    },
    {
        path: `${ROUTE_BASE_URL}/currency`,
        name: 'currency',
        exact: true,
        pageTitle: "currency",
        component: Currency
    },
    {
        path: `${ROUTE_BASE_URL}/notifications`,
        name: 'Notifications',
        exact: true,
        pageTitle: "Notifications",
        component: Notifications
    },
    {
        path: `${ROUTE_BASE_URL}/dashboard`,
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Dashboard
    },
    {
        path: `${ROUTE_BASE_URL}/settings`,
        name: 'settings',
        exact: true,
        pageTitle: "Settings",
        component: Sttings
    },

    {
        path: `${ROUTE_BASE_URL}/payment`,
        name: 'Payment',
        exact: true,
        pageTitle: "Payment",
        component: Payment
    },
    {
        path: `${ROUTE_BASE_URL}/invoice`,
        name: 'Invoice',
        exact: true,
        pageTitle: "Invoice",
        component: Invoice
    },
    {
        path: `${ROUTE_BASE_URL}/membership-certificate`,
        name: 'Membership Certificate',
        exact: true,
        pageTitle: "Membership Certificate",
        component: MembershipCertificate
    },
    {
        path: `${ROUTE_BASE_URL}/fmas-certificate`,
        name: 'FMAS Certificate',
        exact: true,
        pageTitle: "FMAS Certificate",
        component: FMASCertificate
    },
    {
        path: `${ROUTE_BASE_URL}/push-notification`,
        name: 'Push Notification',
        exact: true,
        pageTitle: "Push Notification",
        component: PushNotification
    },
    {
        path: `${ROUTE_BASE_URL}/application-queries`,
        name: 'Application Queries',
        exact: true,
        pageTitle: "Application Queries",
        component: ApplicationQueries
    },
    {
        path: `${ROUTE_BASE_URL}/access-denied`,
        name: 'User Permission',
        exact: true,
        pageTitle: "User Permission",
        component: AccessDenied 
    },
    // {
    //     path: `${ROUTE_BASE_URL}/login`,
    //     name: 'login',
    //     exact: true,
    //     pageTitle: "Tables",
    //     component: Login
    // },
    // {
    //     path: `${ROUTE_BASE_URL}/signup`,
    //     name: 'signup',
    //     exact: true,
    //     pageTitle: "Tables",
    //     component: Signup
    // },
    // {
    //     path: `${ROUTE_BASE_URL}/forgotpassword`,
    //     name: 'forgotpassword',
    //     exact: true,
    //     pageTitle: "Tables",
    //     component: ForgotPassword
    // },
    // {
    //     path: `${ROUTE_BASE_URL}/notfound`,
    //     name: 'notfound',
    //     exact: true,
    //     pageTitle: "Tables",
    //     component: NotFound
    // }

];

export default Routes;